/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bloco[_ngcontent-%COMP%]{border:1px solid #dedede;border-top:0}h5.titulo[_ngcontent-%COMP%]{margin:0;background:#f7f7f7;padding:10px;border-bottom:1px solid #dedede;font-weight:700}.row[_ngcontent-%COMP%]{margin:0}.item[_ngcontent-%COMP%]{margin:0;padding:10px;font-size:14px}.item[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin:0;padding:0;display:block}table[_ngcontent-%COMP%]{font-size:14px}\n/*# sourceMappingURL=cadastral-pj.component.css.map*/"];
export { styles as styles };
